const ALLOWED_REFERER_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "dmc-mact.ru",
]);

export function getYmapsRefererHint() {
  if (typeof window === "undefined") {
    return "";
  }
  const host = window.location.hostname;
  if (ALLOWED_REFERER_HOSTS.has(host) || host.endsWith(".dmc-mact.ru")) {
    return "";
  }
  const path = window.location.pathname || "/virus";
  return (
    ` Сейчас открыто с «${host}» — Referer не совпадает с кабинетом. ` +
    `Используйте http://localhost:3010${path} или добавьте «${host}» в Referer (отдельной строкой, без http://).`
  );
}

export function getYmaps403BaseMessage() {
  return (
    "Не удалось загрузить карту (403). В кабинете Яндекса для ключа сохраните Referer " +
    "(по одному домену в строке, без http://): localhost, 127.0.0.1, dmc-mact.ru. " +
    "После сохранения подождите до 1 часа."
  );
}
